// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4ecdcb5e] .avue-crud .el-table .el-form-item{margin-bottom:1px!important}[data-v-4ecdcb5e] .avue-crud__pagination{position:relative;padding:5px 0 10px 10px;text-align:right}[data-v-4ecdcb5e] .avue-crud__empty{padding:10px 0}", ""]);
// Exports
module.exports = exports;
